module.exports = __webpack_public_path__ + "media/images/core_values/dependability-f4714bc7f601efe93fae007fec3b5344.png";